
String.format = stringFormat;

String.newGuid = newGuid;


/**
 * Hàm loại bỏ ký tự ở cuối chuỗi
 * @param {string} char kí tự cần loại bỏ
 * @param {boolean} isReplaceAll loại bỏ tất cả kí tự ở cuối hay không
 * @CreatedBy NDCong 24/6/2020
 */
String.prototype.trimEnd = function(char = " ", isReplaceAll = true) {
  let r = new RegExp(`${char}$`, "g");
  if (isReplaceAll) {
    r = new RegExp(`${char}*$`, "g");
  }
  return this.replace(r, "");
}

/**
 * Hàm loại bỏ kí tự ở đầu chuối
 * @param {string} char kí tự cần loại bỏ
 * @param {boolean} isReplaceAll loại bỏ tất cả kí tự ở đầu hay không
 * @CreatedBy NDCong 24/9/2020
 */
String.prototype.trimStart = function(char = " ", isReplaceAll = true) {
  let r = new RegExp(`^${char}`, "g");
  if (isReplaceAll) {
    r = new RegExp(`^${char}*`, "g");
  }
  return this.replace(r, "");
}

/**
 * Hàm string format 
 * @param {string} template
 * @param {Array<string>} args
 * @CreatedBy NDCong 24/9/2020
 */
function stringFormat(template, ...args) {
  for (let i = 0; i < args.length; i++) {
    const regexp = new RegExp("\\{" + i + "\\}", "gi");
    template = template.replace(regexp, args[i]);
  }
  return template;
}

/**
* Sinh guid dưới client
* CreatedBy NDCong 24/9/2020
*/
function newGuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
 }